document.addEventListener("open:quickview", function(event) {
    const detail = event.detail
    const productId = detail.productId

    const quickView = document.querySelector('#Quick-view')
    const form = quickView.querySelector(`product-form[data-product-id="${productId}"]`).children[0]
    const subscriptionBlock = quickView.querySelector(`.subscription-block[data-product-id="${productId}"]`)

    injectSellingPlan(form)
    addHandler(form, subscriptionBlock)
})

function addHandler(form, subscriptionBlock) {
    const oneTimeRadio = subscriptionBlock.querySelector('input[name="purchase_option"][value="one_time"]');
    const subscriptionRadio = subscriptionBlock.querySelector('input[name="purchase_option"][value="subscription"]');
    const dropdown = subscriptionBlock.querySelector('#subscription-dropdown');

    function updateDropdownState() {
      const hiddenInput = form.querySelector('input[type="hidden"][name="selling_plan"]');

      if (subscriptionRadio && subscriptionRadio.checked) {
        dropdown.disabled = false;
        // If a plan is selected, update the hidden input
        if (dropdown.value) {
          hiddenInput.value = dropdown.value;
        }
      } else {
        dropdown.disabled = true;
        dropdown.value = "";
        hiddenInput.value = "";
      }
    }

    if (oneTimeRadio) {
      oneTimeRadio.addEventListener('change', updateDropdownState);
    }
    if (subscriptionRadio) {
      subscriptionRadio.addEventListener('change', updateDropdownState);
    }

    if (dropdown) {
      dropdown.addEventListener('change', function(event) {
        const hiddenInput = form.querySelector('input[type="hidden"][name="selling_plan"]');
        if (subscriptionRadio && subscriptionRadio.checked) {
          console.debug(`Current value: ${event.target.value}`)
          hiddenInput.value = event.target.value;
        }
      });
    }

    updateDropdownState();
}

function injectSellingPlan(form) {
    const hiddenInput = document.createElement("input")
    hiddenInput.setAttribute("name", "selling_plan")
    hiddenInput.setAttribute("type", "hidden")
    hiddenInput.setAttribute("value", "")
    hiddenInput.classList.add("selling-plan")

    form.appendChild(hiddenInput)
}
